// extracted by mini-css-extract-plugin
module.exports = {"root":"ModifySelectedRooms_root__2wkBi","closeButton":"ModifySelectedRooms_closeButton__mw5Pv"};